import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme, "theme");

  return {
    id: id,
    elements: [
      {
        type: "text",
        id: "o3MJgj9hBb",
        width: 200.81,
        height: 118.65,
        left: 553.16,
        top: 156.02,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content:
          '<p style="text-align: justify;"><span style="color: #FEE6AE;font-size: 89.8px;font-family: Arial;text-shadow: 2.21px 2.21px 3.13px #000000;">目录</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "MWAsjsHdE5",
        width: 176.49,
        height: 30.29,
        left: 565.3199999999999,
        top: 259.1,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content:
          '<p style="text-align: justify;"><span style="color: #FEE6AE;font-size: 18.37px;font-family: Arial;text-shadow: 2.21px 2.21px 3.13px #000000;">CONTENTES</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "FKQsx5EgLg",
        left: 120.4541792547834,
        top: 137.23308734055047,
        width: 361.664988251091,
        height: 241.921875,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#fff",
        vertical: false,
      },
    ],
    background,
  };
}
